import styled from 'styled-components';

export const Button = styled.button`
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
`;
